<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Digitalizador 2.0 — Listado",
            items: [
                { text: "Digitalizador 2.0", href: "/web/digitalizador2/subir" },
                { text: "Listado", active: true },
            ],
            documentos: [],
            cargando: true,
            paginaActual: 1,
            porPagina: 20,
            totalRegistros: 0,
            filtroEstado: "",
            busqueda: "",
            // detalle modal
            documentoSeleccionado: null,
            resultadoSeleccionado: null,
            cargandoDetalle: false,
        };
    },

    created() {
        if (!this.user || this.user.rol !== "Admin") {
            window.location.href = "/";
            return;
        }
        this.cargarListado();
    },

    computed: {
        documentosFiltrados() {
            let docs = this.documentos;
            if (this.filtroEstado) {
                docs = docs.filter((d) => d.status === this.filtroEstado);
            }
            if (this.busqueda.trim()) {
                const q = this.busqueda.trim().toLowerCase();
                docs = docs.filter(
                    (d) =>
                        (d.request_id || "").toLowerCase().includes(q) ||
                        (d.event_name || "").toLowerCase().includes(q) ||
                        (d.event_id || "").toLowerCase().includes(q) ||
                        (d.document_type || "").toLowerCase().includes(q)
                );
            }
            return docs;
        },

        filas() {
            return this.documentosFiltrados.length;
        },
    },

    methods: {
        async cargarListado() {
            this.cargando = true;
            try {
                const res = await axios.get("/api/digitalizador2/listado", {
                    params: { page: this.paginaActual, per_page: this.porPagina },
                });
                const data = res.data;
                this.documentos       = data.data || data.documents || data || [];
                this.totalRegistros   = data.total || this.documentos.length;
            } catch (err) {
                console.error("Error cargando listado:", err);
            } finally {
                this.cargando = false;
            }
        },

        async verDetalle(doc) {
            this.documentoSeleccionado = doc;
            this.resultadoSeleccionado = null;
            this.cargandoDetalle = true;
            this.$bvModal.show("modal-detalle");
            try {
                const res = await axios.get(`/api/digitalizador2/result/${doc.request_id}`);
                this.resultadoSeleccionado = res.data;
            } catch (_) {
                // resultado aún no disponible
            } finally {
                this.cargandoDetalle = false;
            }
        },

        abrirDemo(requestId) {
            window.open(`https://apidocs.alegoria.cl/demo/results/${requestId}`, "_blank");
        },

        estadoBadge(estado) {
            const map = {
                pending:      "warning",
                processing:   "info",
                completed:    "success",
                failed:       "danger",
                needs_review: "warning",
            };
            return map[estado] || "secondary";
        },

        estadoLabel(estado) {
            const map = {
                pending:      "En cola",
                processing:   "Procesando",
                completed:    "Completado",
                failed:       "Error",
                needs_review: "Requiere revisión",
            };
            return map[estado] || estado;
        },

        formatFecha(fecha) {
            if (!fecha) return "—";
            return new Date(fecha).toLocaleString("es-CL", {
                dateStyle: "short",
                timeStyle: "short",
            });
        },

        confianzaPct(conf) {
            if (conf == null) return "—";
            return Math.round(conf * 100) + "%";
        },

        confianzaColor(conf) {
            if (conf == null) return "secondary";
            if (conf >= 0.85) return "success";
            if (conf >= 0.6)  return "warning";
            return "danger";
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row mb-3">
            <div class="col-md-4">
                <input
                    v-model="busqueda"
                    type="text"
                    class="form-control"
                    placeholder="Buscar por ID, evento o tipo…"
                />
            </div>
            <div class="col-md-3">
                <select v-model="filtroEstado" class="form-control">
                    <option value="">Todos los estados</option>
                    <option value="pending">En cola</option>
                    <option value="processing">Procesando</option>
                    <option value="completed">Completado</option>
                    <option value="needs_review">Requiere revisión</option>
                    <option value="failed">Error</option>
                </select>
            </div>
            <div class="col-md-2">
                <button class="btn btn-outline-secondary" @click="cargarListado">
                    <i class="bx bx-refresh mr-1"></i> Actualizar
                </button>
            </div>
            <div class="col-md-3 text-right">
                <a href="/web/digitalizador2/subir" class="btn btn-primary">
                    <i class="bx bx-upload mr-1"></i> Subir nueva ficha
                </a>
            </div>
        </div>

        <div class="card">
            <div class="card-body p-0">
                <!-- Loading -->
                <div v-if="cargando" class="text-center py-5">
                    <i class="bx bx-loader bx-spin display-4 text-primary"></i>
                    <p class="mt-2 text-muted">Cargando documentos…</p>
                </div>

                <!-- Tabla -->
                <div v-else-if="documentosFiltrados.length" class="table-responsive">
                    <table class="table table-hover mb-0">
                        <thead class="thead-light">
                            <tr>
                                <th>Request ID</th>
                                <th>Tipo documento</th>
                                <th>Evento</th>
                                <th class="text-center">Estado</th>
                                <th class="text-center">Páginas</th>
                                <th>Fecha</th>
                                <th class="text-center">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="doc in documentosFiltrados" :key="doc.request_id">
                                <td>
                                    <code class="small">{{ doc.request_id ? doc.request_id.substring(0, 8) + '…' : '—' }}</code>
                                </td>
                                <td>{{ doc.document_type || '—' }}</td>
                                <td>
                                    <span v-if="doc.event_name">{{ doc.event_name }}</span>
                                    <small v-if="doc.event_id" class="d-block text-muted">{{ doc.event_id }}</small>
                                    <span v-if="!doc.event_name && !doc.event_id" class="text-muted">—</span>
                                </td>
                                <td class="text-center">
                                    <span :class="`badge badge-${estadoBadge(doc.status)} px-2`">
                                        {{ estadoLabel(doc.status) }}
                                    </span>
                                </td>
                                <td class="text-center">{{ doc.page_count || '—' }}</td>
                                <td>
                                    <small>{{ formatFecha(doc.created_at) }}</small>
                                </td>
                                <td class="text-center">
                                    <button
                                        class="btn btn-outline-primary btn-sm mr-1"
                                        title="Ver detalle"
                                        @click="verDetalle(doc)"
                                    >
                                        <i class="bx bx-search-alt"></i>
                                    </button>
                                    <button
                                        v-if="doc.status === 'completed' || doc.status === 'needs_review'"
                                        class="btn btn-outline-info btn-sm"
                                        title="Vista demo"
                                        @click="abrirDemo(doc.request_id)"
                                    >
                                        <i class="bx bx-link-external"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Sin resultados -->
                <div v-else class="text-center py-5 text-muted">
                    <i class="bx bx-file display-4 mb-2"></i>
                    <p>No se encontraron documentos.</p>
                    <a href="/web/digitalizador2/subir" class="btn btn-primary btn-sm">
                        Subir primera ficha
                    </a>
                </div>
            </div>
        </div>

        <!-- Modal de detalle -->
        <b-modal
            id="modal-detalle"
            size="xl"
            :title="documentoSeleccionado ? 'Detalle: ' + (documentoSeleccionado.request_id || '') : 'Detalle'"
            hide-footer
            scrollable
        >
            <div v-if="cargandoDetalle" class="text-center py-4">
                <i class="bx bx-loader bx-spin display-4 text-primary"></i>
            </div>

            <div v-else-if="resultadoSeleccionado">
                <div v-if="resultadoSeleccionado.items && resultadoSeleccionado.items.length">
                    <table class="table table-sm table-bordered">
                        <thead class="thead-light">
                            <tr>
                                <th>Campo</th>
                                <th>Valor</th>
                                <th class="text-center">Confianza</th>
                                <th class="text-center">Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(item, idx) in resultadoSeleccionado.items"
                                :key="idx"
                                :class="item.status === 'approved' ? 'table-success' : ''"
                            >
                                <td class="font-weight-bold small">{{ item.label || item.field }}</td>
                                <td>{{ item.corrected_value || item.value || '—' }}</td>
                                <td class="text-center">
                                    <span :class="`badge badge-${confianzaColor(item.confidence)}`">
                                        {{ confianzaPct(item.confidence) }}
                                    </span>
                                </td>
                                <td class="text-center">
                                    <span v-if="item.status === 'approved'" class="text-success small">
                                        <i class="bx bx-check-double"></i> Aprobado
                                    </span>
                                    <span v-else-if="item.status === 'corrected'" class="text-info small">
                                        <i class="bx bx-edit"></i> Corregido
                                    </span>
                                    <span v-else class="text-muted small">Pendiente</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p v-else class="text-muted text-center py-3">No hay campos en el resultado.</p>

                <div v-if="documentoSeleccionado && (documentoSeleccionado.status === 'completed' || documentoSeleccionado.status === 'needs_review')" class="text-right mt-2">
                    <button class="btn btn-outline-info btn-sm" @click="abrirDemo(documentoSeleccionado.request_id)">
                        <i class="bx bx-link-external mr-1"></i> Ver vista demo AlegoriaDoc
                    </button>
                </div>
            </div>

            <div v-else class="text-center py-3 text-muted">
                <p>El resultado aún no está disponible para este documento.</p>
            </div>
        </b-modal>
    </Layout>
</template>
